import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'adaPrerequisiteObjectId' })
export class PrerequisiteObjectIdPipe implements PipeTransform {
	public transform(_value: long | ({ value: long })[]): long[] {
		if (Array.isArray(_value))
			return _value.map(v => v.value);

		return [_value];
	}
}
